import type { ApiResponse } from '../../../../config/api-types'
import { Exception } from '../../../../errors/exception'
import { HttpStatusCode } from '../../../../errors/http-status-code'
import type { ResetPasswordRequest } from '../../domain/models/reset-password'
import type { IResetPassword } from '../../domain/use-cases/i-reset-password'
import type { IResetPasswordClient } from '../data-sources/i-reset-password-client'

export class ResetPasswordRepository implements IResetPassword {
  constructor(private readonly dataSource: IResetPasswordClient) {}

  async reset(params: ResetPasswordRequest): Promise<ApiResponse> {
    const result = await this.dataSource.reset(params)

    if (result.status !== HttpStatusCode.OK) {
      throw new Exception(result.status, result?.message!)
    }

    return result
  }
}
